import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_USERPERM_GQL,
  // GET_USERGRPERM_GQL,
  // U_PERMISSION_INSERT_GQL,
  GET_USERPAGEPERM_GQL,
  GET_ROLL_NAME_GQL,
  GET_MODULE_PERM_LIST_GQL,
  GET_PERM_IDS_GQL,
  U_PERM_TEAM_CONNECT_GQL,
  GET_MODULES_DEFAULT_ROLE_PERMISSIONS_GQL,
  REMOVE_USER_TEAM_PERM_GQL,
  UPDATE_USER_TEAM_PERM_GQL,
  GET_PERM_ONLY_ALLTEAM_GQL,
  REMOVE_DUPLICATE_USER_PERM_GQL,
  EDIT_MANY_TEAM_TO_USERS_GQL,
} from '@/graphql/queries.gql';

export default {
  namespaced: true,

  state: {
    userPerms: [],
    // userGrPerms: [],
    // addUserGrPermInfo: [],
    // userPagePerms: [],
    userRolePerms: [],
    modulePermList: [],
    userPermIds: [],
    adduserRolePerms: [],
    removeuserRolePerms: [],
    editUserRolePerms: [],
    moduleDefaultRolePermissions: [{}],
    getPermOnlyAllTeam: [],
    removeDuplicateUserPerms: null,
    getEditedTeamToUserCnt: null,
    permOnlyForFlagZero: null,
  },

  mutations: {
    GET_PERM_ONLY_FOR_FLAG_ZERO(state, payload) {
      state.permOnlyForFlagZero = payload;
    },
    GET_USERPERM_LIST(state, payload) {
      state.userPerms = payload;
    },
    GET_PERM_ID_LIST(state, payload) {
      state.userPermIds = payload;
    },
    GET_MODULE_PERM_LIST(state, payload) {
      state.modulePermList = payload;
    },
    // GET_USERGRPERM_LIST(state, payload) {
    //   state.userGrPerms = payload;
    // },
    // ADD_USERGRPERM_INFO(state, payload) {
    //   state.addUserGrPermInfo = payload;
    // },
    // GET_USERPAGEPERM_LIST(state, payload) {
    //   state.userPagePerms = payload;
    // },
    SET_ROLE_PERM(state, payload) {
      state.userRolePerms = payload;
    },
    ADD_USER_TEAM_PERM_INFO(state, payload) {
      state.adduserRolePerms = payload;
    },
    // SET_USER_TEAM_LEFT_PANEL(state, payload) {
    //   console.log(payload);
    //   console.log(state.getUserWithGrList);
    //   const userDetails = state.getUserWithGrList.find(user => user.id === payload.user.id);
    //   userDetails.teams = payload;
    //   console.log(state.getUserWithGrList);
    // },
    REMOVE_USER_TEAM_PERM_INFO(state, payload) {
      state.removeuserRolePerms = payload;
    },
    EDIT_USER_TEAM_PERM_INFO(state, payload) {
      state.editUserRolePerms = payload;
    },
    SET_MODULE_DEFAULT_ROLE_PERMISSIONS(state, payload) {
      state.moduleDefaultRolePermissions = payload;
    },
    GET_PERM_ONLY_ALL_TEAM(state, payload) {
      state.getPermOnlyAllTeam = payload;
    },
    REMOVE_DUPLICATE_USER_PERM_INFO(state, payload) {
      state.removeDuplicateUserPerms = payload;
    },
    GET_EDITED_TEAM_TO_USERS_CNT(state, payload) {
      state.getEditedTeamToUserCnt = payload;

    },
  },

  actions: {
    // = methods
    // destructuring `context.commit` by doing `{ commit }`
    async getUserPerms({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_USERPERM_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_USERPERM_LIST', data.userPerms);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    // getGrUserPerms({ commit }, payload) {
    //   commit('shared/SET_LOADING', true, { root: true });
    //   apolloClient
    //     .query({
    //       query: GET_USERGRPERM_GQL,
    //       variables: {
    //         userId: payload.userId,
    //         permStatus: payload.permStatus,
    //         group: payload.groupId,
    //       },
    //     })
    //     .then(({ data }) => {
    //       commit('GET_USERGRPERM_LIST', data.userPerms);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     });
    // },

    // addGrUserPerms({ commit }, payload) {
    //   commit('shared/SET_LOADING', true, { root: true });
    //   apolloClient
    //     .mutate({
    //       mutation: U_PERMISSION_INSERT_GQL,
    //       variables: {
    //         userId: payload.userId,
    //         typeId: payload.typeId,
    //         group: payload.groupId,
    //         permStatus: payload.permStatus,
    //         permFlag: payload.permFlag,
    //       },
    //     })
    //     .then(({ data }) => {
    //       commit('ADD_USERGRPERM_INFO', data.userPerms);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     });
    // },
    // getUserPagePerms({ commit }, payload) {
    //   commit('shared/SET_LOADING', true, { root: true });
    //   apolloClient
    //     .query({
    //       query: GET_USERPAGEPERM_GQL,
    //       variables: {
    //         userId: payload.userId,
    //         permStatus: payload.permStatus,
    //         module: payload.module,
    //       },
    //     })
    //     .then(({ data }) => {
    //       commit('GET_USERPAGEPERM_LIST', data.userPerms);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       commit('shared/SET_LOADING', false, { root: true });
    //     });
    // },
    // temp created
    getPageRolePerm({ commit }, payload) {
      if (payload.userType === 'Admin') {
        const roleInfo = {};
        roleInfo.userPerm = 2;
        roleInfo.typeName = 'Admin';

        commit('shared/SET_LOADING', false, {
          root: true,
        });
        commit('SET_ROLE_PERM', roleInfo);
      } else if (payload.id != null) {
        apolloClient
          .query({
            query: GET_ROLL_NAME_GQL,
            variables: payload,
            fetchPolicy: 'network-only',
          })
          .then(({ data }) => {
            const roleInfo = {};
            localStorage.setItem('userRoleName', data.getUserRole.typeName);
            if (data.getUserRole.typeName === 'Admin') {
              roleInfo.userPerm = 2;
              roleInfo.typeName = data.getUserRole.typeName;

              commit('shared/SET_LOADING', false, {
                root: true,
              });
              commit('SET_ROLE_PERM', roleInfo);
            } else {
              roleInfo.typeName = data.getUserRole.typeName;
              apolloClient
                .query({
                  query: GET_USERPAGEPERM_GQL,
                  variables: {
                    userId: payload.userId,
                    permStatus: payload.permStatus,
                    module: payload.module,
                  },
                })
                .then(({ data2 }) => {

                  roleInfo.userPerms = data2.userPerms;
                  roleInfo.userPerm = data2.userPerms[0].permFlag;
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                  commit('SET_ROLE_PERM', roleInfo);
                })
                .catch((err) => {
                  console.log(err);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        localStorage.setItem('userRoleName', 'Employee');
      }
    },
    getModulePerms({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_MODULE_PERM_LIST_GQL,
          variables: payload,
        })
        .then(({ data }) => {

          commit('GET_MODULE_PERM_LIST', data.modules);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getPermIds({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_PERM_IDS_GQL,
          variables: {
            userId: payload.userId,
            group: payload.groupId,
          },
        })
        .then(({ data }) => {
          const permIds = [];
          data.userPerms.forEach((permission) => {
            permIds.push(permission.permission.id);
          });
          commit('GET_PERM_ID_LIST', permIds);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    addTeamUserPerms({ commit }, payload) {

      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: U_PERM_TEAM_CONNECT_GQL,
          variables: {
            userId: payload.userId,
            roleId: payload.roleId,
            overrideDefaultPermissions: payload.overrideDefaultPermissions,
            teamId: payload.teamId,
            permId: payload.permId,
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {

          commit('ADD_USER_TEAM_PERM_INFO', data.createTeamToUser);

          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    editTeamUserPerms({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: UPDATE_USER_TEAM_PERM_GQL,
          variables: {
            userId: payload.userId,
            roleId: payload.roleId,
            overrideDefaultPermissions: payload.overrideDefaultPermissions,
            teamId: payload.teamId,
            permId: payload.permId,
            id: payload.id,
          },
        })
        .then(({ data }) => {
          commit('EDIT_USER_TEAM_PERM_INFO', data.updateTeamToUser);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    removeTeamUserPerms({ commit }, payload) {

      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: REMOVE_USER_TEAM_PERM_GQL,
          variables: {
            id: payload.id,
            recordStatus: payload.recordStatus,
          },
        })
        .then(({ data }) => {
          commit('REMOVE_USER_TEAM_PERM_INFO', data.removeTeamFromUser);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    removeDuplicateTeamUserPerms({ commit }, payload) {

      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: REMOVE_DUPLICATE_USER_PERM_GQL,
          variables: {
            teamId: payload.teamId,
            userId: payload.userId,
            recordStatus: payload.recordStatus,
          },
        })
        .then(({ data }) => {

          commit('REMOVE_DUPLICATE_USER_PERM_INFO', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getModuleDefaultRolePermissions({ commit }) {
      apolloClient
        .query({
          query: GET_MODULES_DEFAULT_ROLE_PERMISSIONS_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {

          commit('SET_MODULE_DEFAULT_ROLE_PERMISSIONS', data.moduleDefaultRolePermissions);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getPermAllTeam({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_PERM_ONLY_ALLTEAM_GQL,
          variables: {
            flag: payload.flag,
          },
        })
        .then(({ data }) => {

          if (payload.flag === 0) {
            commit('GET_PERM_ONLY_FOR_FLAG_ZERO', data.permissions);
          } else {
            commit('GET_PERM_ONLY_ALL_TEAM', data.permissions);
          }
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    editManyTeamToUsers({ commit }, payload) {

      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: EDIT_MANY_TEAM_TO_USERS_GQL,
          variables: {
            teamId: payload.teamId,
            recordStatus: payload.recordStatus,
          },
        })
        .then(({ data }) => {

          commit('GET_EDITED_TEAM_TO_USERS_CNT', data.updateManyTeamToUsers);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
  },

  getters: {
    // = computed properties
    userPerms: state => state.userPerms,
    userRolePerms: state => state.userRolePerms,
    modulePermList: state => state.modulePermList,
    userPermIds: state => state.userPermIds,
    adduserRolePerms: state => state.adduserRolePerms,
    moduleDefaultRolePermissions: state => state.moduleDefaultRolePermissions,
    removeuserRolePerms: state => state.removeuserRolePerms,
    editUserRolePerms: state => state.editUserRolePerms,
    getPermOnlyAllTeam: state => state.getPermOnlyAllTeam,
    removeDuplicateUserPerms: state => state.removeDuplicateUserPerms,
    getEditedTeamToUserCnt: state => state.getEditedTeamToUserCnt,
    permOnlyForFlagZero: state => state.permOnlyForFlagZero,
  },
};
